export const paths = {
	root: '/AckMgmt'
};